export interface RetrospectiveGainsBreakdown {
  gridSize: number;
  totalDraws: number;
  winningDraws: number;
  winRate: number;
  totalGainCents: number;
  totalSpentCents: number;
  netCents: number;
  biggestGain: {
    date: string;
    matchCount: number;
    gainCents: number;
  } | null;
  bestStreak: number;
  periodStart: string | null;
  periodEnd: string | null;
}

export interface RetrospectiveGainsResponse {
  configured: boolean;
  combinationId?: number;
  combinationName?: string;
  playerNumbers?: number[];
  hasFullAccess?: boolean;
  /** Si non-null, l'utilisateur free n'a vu que les N derniers tirages. */
  limitApplied?: number | null;
  gains: RetrospectiveGainsBreakdown | null;
}

export async function getRetrospectiveGains(
  betCents = 100,
): Promise<RetrospectiveGainsResponse> {
  const res = await fetch(
    `/_api/auth/my-draw/retrospective-gains?bet=${betCents}`,
  );
  if (!res.ok) throw new Error("Erreur lors du chargement des gains rétrospectifs");
  return res.json();
}
